module.exports = __webpack_public_path__ + "static/img/FITmenu05.a56d507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu05.png
// module id = 5Tab
// module chunks = 1